import PopoverV2 from "../../core/gd-components/gd-popover/popover-v2"
import Popover from "../../core/gd-components/gd-popover/popover"

// const debug = "Popovers"
const debug = false

export default class Popovers {

    popovers        : (Popover | PopoverV2)[]

    constructor() {
        this.popovers = []
    }

    register(popover: Popover | PopoverV2) {
        this.popovers.push(popover)
    }

    unregister(popover: Popover | PopoverV2) {
        this.popovers.remove(popover)
    }

    closeAll():void {
        // console.log(this.popovers)
        _.map(this.popovers, (popover : Popover | PopoverV2) => {

            if (popover) {
                popover.props?.onClickOutside?.()
            } else {
                console.warn("#937262  - how come popover=", popover)
            }


        })
    }
}
